import store from '../store/store';

export default function getTargetLanguageTag() {
    return store.settings.targetLanguage ? store.settings.targetLanguage : store.userLanguageTag;
}
